import { render, staticRenderFns } from "./technical.vue?vue&type=template&id=83cb6bec&scoped=true"
import script from "./technical.vue?vue&type=script&lang=js"
export * from "./technical.vue?vue&type=script&lang=js"
import style0 from "./technical.vue?vue&type=style&index=0&id=83cb6bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cb6bec",
  null
  
)

export default component.exports